import { render, staticRenderFns } from "./cate07.vue?vue&type=template&id=1edd93a4"
import script from "./cate07.vue?vue&type=script&lang=js"
export * from "./cate07.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports